/* eslint-disable
    array-callback-return,
    func-names,
    no-prototype-builtins,
    no-useless-escape,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const deps = [];

module.exports = angular.module('bench.ui.form.input', deps).directive('blInput', () => {
  let $$id = 0;

  return {
    restrict: 'E',
    template(elem, attrs) {
      const $id = $$id++;
      const id = `bl-input-${$id}`;

      // set defaults
      _.defaults(attrs, {
        type: 'text',
        name: _.camelCase(attrs.label),
        id,
      });

      // attrs that go into input
      const inputAttrs = _(
        [
          'id',
          'type',
          'name',
          'ng-model',
          'value',
          'required',
          'ng-required',
          'readonly',
          'ng-readonly',
          'step',
          'bl-datepicker',
          'datepicker-opts',
          'justify-right',
          'ng-change',
          'ng-pattern',
        ].map(attr => {
          if (attrs.hasOwnProperty(_.camelCase(attr))) {
            const attrVal = attrs[_.camelCase(attr)];
            elem.removeAttr(attr);
            if (!_.isEmpty(attrVal)) {
              return `${attr}=\"${attrVal}\"`;
            }
            return attr;
          }
        }),
      )
        .compact()
        .join('\n');

      return `\
<input ${inputAttrs}>
<label
    for="${id}"
    placeholder="${attrs.label}"
    alt="${attrs.label}">
</label>\
`;
    },

    link(scope, elem, attrs) {
      const $input = elem.find('input');
      const toggleClasses = function () {
        if ($input.val().length === 0 && !$input.hasClass('ng-invalid')) {
          $input.addClass('empty');
          return $input.removeClass('non-empty');
        }
        $input.addClass('non-empty');
        return $input.removeClass('empty');
      };

      toggleClasses();

      // debounce to avoid fast double function run
      const debouncedToggleClasses = _.debounce(toggleClasses, 1);

      // watch for changes and toggle empty/non-empty classes
      if (attrs.ngModel != null) {
        scope.$watch(attrs.ngModel, debouncedToggleClasses);
      }
      return $input.on('keyup change', debouncedToggleClasses);
    },
  };
});
